export const ACTION = {
  CREATE_EDIT_DRAFT:  'CASE:NEW_EDIT_DRAFT'
};

export class CreateEditDraft{
  public type: string = ACTION.CREATE_EDIT_DRAFT;
  public caseId: number;

  constructor(caseId: number) {
    this.caseId = caseId;
  }
}
